jQuery(document).ready(function() {
    var items    = jQuery('.faq-item');
    var DURATION = 300;

    if (!items.length) {
        return;
    }

    items.each(function() {
        var $item    = jQuery(this);
        var $summary = $item.find('summary');
        var $icon    = $item.find('.faq-item__icon');
        var $answer  = $item.find('.faq-item__answer');

        // Initial ARIA/visibility/icon state
        $summary
            .attr('role', 'button')
            .attr('aria-expanded', $item.is('[open]') ? 'true' : 'false');
        if ($item.is('[open]')) {
            $answer.show();
            $icon.css('transform', 'rotate(135deg)');
        } else {
            $answer.hide();
            $icon.css('transform', 'rotate(0deg)');
        }

        // Click handler
        $summary.on('click', function(e) {
            e.preventDefault();

            // Close any other open items
            items.each(function() {
                var $other    = jQuery(this);
                var $otherSum = $other.find('summary');
                var $otherIc  = $other.find('.faq-item__icon');
                var $otherAn  = $other.find('.faq-item__answer');

                if ($other[0] !== $item[0] && $other.is('[open]')) {
                    $otherAn
                        .stop(true, true)
                        .slideUp(DURATION, function() {
                            $other.removeAttr('open');
                            $otherIc.css('transform', 'rotate(0deg)');
                            $otherSum.attr('aria-expanded', 'false');
                        });
                }
            });

            if ($item.is('[open]')) {
                // Close this one
                $answer
                    .stop(true, true)
                    .slideUp(DURATION, function() {
                        $item.removeAttr('open');
                        $icon.css('transform', 'rotate(0deg)');
                        $summary.attr('aria-expanded', 'false');
                    });
            } else {
                // Open this one
                $item.attr('open', '');
                $answer
                    .stop(true, true)
                    .slideDown(DURATION, function() {
                        $icon.css('transform', 'rotate(135deg)');
                        $summary.attr('aria-expanded', 'true');
                    });
            }
        });

        // Keyboard navigation
        $summary.on('keydown', function(e) {
            switch (e.key) {
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    $summary.trigger('click');
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    if ($item.prev().length) {
                        $item.prev().find('summary').focus();
                    }
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    if ($item.next().length) {
                        $item.next().find('summary').focus();
                    }
                    break;
                case 'Home':
                    e.preventDefault();
                    items.first().find('summary').focus();
                    break;
                case 'End':
                    e.preventDefault();
                    items.last().find('summary').focus();
                    break;
            }
        });
    });
});


// about us

document.addEventListener('DOMContentLoaded', function(){
    const logosContainer = document.querySelector('.about-partners__logos');
    if (!logosContainer) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    if (logosContainer) {
        logosContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - logosContainer.offsetLeft;
            scrollLeft = logosContainer.scrollLeft;
        });
        logosContainer.addEventListener('mouseleave', () => {
            isDown = false;
        });
        logosContainer.addEventListener('mouseup', () => {
            isDown = false;
        });
        logosContainer.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - logosContainer.offsetLeft;
            const walk = (x - startX) * 1;
            logosContainer.scrollLeft = scrollLeft - walk;
        });
    }
});